<template>
<v-container class="pa-5">
      <v-row no-gutters justify="center">
     <v-col
      sm="5"
     >
       <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
            <v-card style="margin-top: 12%;" class="pa-2">
              <p class="text-center pt-5">
              <img :src="$store.state.systemlogo" width="120px"/>
              </p>
              <v-card-text>
                    
                      <v-text-field
                        v-model="username"
                        :rules="nameRules"
                        label="Username"
                        required
                        outlined
                      ></v-text-field>
                   
                      <v-text-field
                        v-model="password"
                        :rules="nameRules"
                        label="Password"
                        type="password"
                        v-on:keyup.enter="validate()"
                        required
                        outlined
                      ></v-text-field>
                    
              </v-card-text>
              <v-card-actions class="pt-4 pb-5">
                  <v-btn
                        color="primary"
                        block
                        rounded
                        large
                        @click="validate"
                      >
                        LOGIN BETA
                      </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
     </v-col>
   </v-row>
</v-container>
</template>
<script>
 import md5 from 'md5'
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      valid: true,
      username: '',
      nameRules: [
        v => !!v || 'Field is required'
      ],
      password: '',
      snackbar: false,
    }),
    created() {
      if (this.$session.exists()) {
          this.setLoggedIn(false)
          this.$session.destroy()
      }
      
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      
      validate () {
        if (this.$refs.form.validate()) {
          this.login()
        }
      },
      login(){
         var param = {
            Username: this.username,
            Password: md5(this.password)
          }
          this.$http.post("user/login",param).then(response => {
          console.log( response.data)
          if(response.data.status == true) {
            this.$session.start()
            this.$session.set('jwt', response.data.account.token)
            this.$session.set('username', response.data.account.username)
            this.$session.set('role', response.data.account.role)
            this.$session.set('userID', response.data.account.id)
              this.$session.set('permission', response.data.account.code)
              console.log(response.data.account)
            
            this.setAlertColor('success')
            this.setLoggedIn(true)
            if(response.data.account.role == "administrator"){this.$router.push('/dashboard')}
            if(response.data.account.role == "encoder"){this.$router.push('/encoder')}
            if(response.data.account.role == "dispatcher"){this.$router.push('/dispatcher')}
            if(response.data.account.role == "cashier"){this.$router.push('/cashier')}
            if(response.data.account.role == "weigher"){this.$router.push('/weigher')}
          } else {
            this.setAlertColor('error')
            this.setLoggedIn(false)
          }
            this.setAlertText(response.data.message)
            this.setAlert(true)
          }).catch(e => {
           console.log(e)
         })
        
          
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>